export const completionEventsQueryKeys = {
  all: () => ['/completion-events'] as const,
  list: () => [...completionEventsQueryKeys.all(), 'list'] as const,
};
